export default {
  container: {
    width: '100%',
    height: '100%',
    background: 'rgba(255, 255, 255, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}
